module.exports = __webpack_public_path__ + "static/media/card-design-graduation.2142d70c.png";